const EnumExpressionsNum: { [key: string]: number } = Object.freeze({
  LOST: 1,
  PAUSE: 2,
  GREAT: 3,
  REW: 4,
  FF: 5,
});

export default EnumExpressionsNum;
